<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="visible"
    v-loading="processing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Update Devices</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            :disabled="operationDisabled"
            @click="updateOperation"
          >
            Update
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <dads-select v-model="phPmId" placeholder="Select phone model" filterable>
        <template slot="prefix">Phone model</template>
        <el-option
          v-for="(item, index) in deviceModelOptions"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </dads-select>

      <dads-select
        v-if="provisionFieldsExist"
        v-model="apField"
        placeholder="Config Field"
        filterable
        @change="onConfigFieldSelection"
      >
        <el-option
          v-for="item in provisionSettings"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>

        <template slot="prefix">Config Field</template></dads-select
      >

      <div v-if="selectedProvision">
        <el-input
          v-if="selectedProvision.fieldType === 'Input'"
          v-model="apValue"
          placeholder="Config Value"
        >
          <template slot="prefix">Config Value</template>
        </el-input>

        <el-select
          v-if="selectedProvision.fieldType === 'Select'"
          v-model="apValue"
          placeholder="Config Value"
          filterable
        >
          <el-option
            v-for="(item, i) in selectedProvision.selectOptions[0]"
            :key="i"
            :label="item.label"
            :value="item.value ? item.value : item.label"
          />
          <template slot="prefix">Config Value</template>
        </el-select>
      </div>

      <h2 class="form-section-header">Assign Phone Button Layout</h2>
      <dads-select v-model="blId" placeholder="Button Layout" clearable>
        <el-option
          v-for="item in buttonLayoutOptions"
          :key="item.id"
          :value="item.id"
          :label="item.name"
        />
        <template slot="prefix">Button Layout</template>
      </dads-select>
    </el-form>
  </el-dialog>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";

import { mapActions } from "vuex";

export default {
  name: "BulkUpdateDeviceForm",

  props: {
    clearFormFields: {
      type: Boolean,
      required: true,
    },
    processing: { required: true },
    visible: { required: true },
    deviceModelOptions: { required: true },
  },

  components: { DadsSelect },

  data() {
    return {
      phPmId: null,
      provisionFields: {},
      apField: "",
      apValue: null,
      selectedProvision: null,
      buttonLayoutOptions: [],
      blId: null,
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    operationDisabled() {
      return (
        !this.phPmId ||
        !this.provisionFields ||
        Object.keys(this.provisionFields).length === 0
      );
    },

    provisionFieldsExist() {
      return Object.keys(this.provisionFields).length;
    },

    provisionSettings() {
      return Object.keys(this.provisionFields).sort();
    },
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    async phPmId(val) {
      if (!val) {
        return;
      }

      try {
        this.selectedProvision = null;
        this.apField = "";

        const fields = {};
        const { settings } = await feathersClient
          .service("device-models")
          .get(val, { query: { tenantId: this.selectedTenant.id } });

        settings.forEach((s) => {
          fields[s.fieldName] = s;
        });

        this.provisionFields = fields;
      } catch (err) {
        //
      }
    },

    selectedTenant() {
      this.fetchButtonLayouts();
    },
  },

  methods: {
    ...mapActions("device-models", { getDeviceModel: "get" }),

    clearFields() {
      this.provisionFields = {};
      this.apField = "";
      this.apValue = null;
      this.phPmId = null;
      this.selectedProvision = null;
      this.blId = null;
    },

    updateOperation() {
      const updateBody = {
        tenantId: this.selectedTenant.id,
        phPmId: this.phPmId,
      };

      if (this.selectedProvision) {
        const { labelId, labelType: type } = this.selectedProvision;

        const alId = typeof labelId === "number" ? labelId : 0;

        updateBody.setting = {
          alId,
          type,
          avValue: this.apValue,
        };
      }

      if (this.blId) {
        updateBody.blId = this.blId;
      }

      this.$emit("updateOperation", updateBody);
    },

    onConfigFieldSelection() {
      this.selectedProvision = this.provisionFields[this.apField];
      this.apValue = this.selectedProvision.value;
    },

    cancelOperation() {
      this.$emit("cancelOperation", "bulkUpdate");
    },

    fetchButtonLayouts() {
      feathersClient
        .service("button-layouts")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        })
        .then((res) => {
          this.buttonLayoutOptions = [...res];
        });
    },
  },

  created() {
    this.fetchButtonLayouts();
  },
};
</script>
